// extracted by mini-css-extract-plugin
export default {"joystick":"Joystick_joystick__jF7iT","active":"Joystick_active__qbA0n","knob":"Joystick_knob__qQBya"};